/**
 * Utils Factory
 */
(function() {

    'use strict';

    angular.module('itxApp.common')
        .service('ProductViewedCacheSvc', ProductViewedCacheSvc);

    ProductViewedCacheSvc.$inject = [
        
    ];

    function ProductViewedCacheSvc() {

        var cache = null;

        var loadCache = function(){
            try{
                cache = JSON.parse(inditex.getLocalStorage('LAST_VIEWED_NAVIGATION'));
            }
            catch(e){
                console.error('ERRROR [productViewedCache] error parsing cache');
                cache = [];
            }
            if(!cache || !_.isArray(cache)){
                cache = [];
            }
        };
        var _addProduct = function(productId, colorId, categoryId, set){
            if(!cache){
                loadCache(); 
            }

            if(cache>=10){
                cache = cache.shift();
            }
           
            cache.push( { 
                productId,
                colorId,
                categoryId,
                set
            });
            inditex.setLocalStorage('LAST_VIEWED_NAVIGATION',JSON.stringify(cache));
        };
        var _getProduct = function(productId){
           
            if(!cache){
                loadCache();
            }
            return _.find(cache, function(elem){return elem.productId === productId;});
        };
       
        return  {
           
            getProduct: _getProduct,
            addProduct:_addProduct

        };

      
    }
})();